import { Link } from "react-router-dom";
import { Facebook, Car, Music2, Phone, Mail, MapPin } from "lucide-react";
import { SITE } from "@/lib/site";

export default function Footer() {
    return (
        <footer className="relative bg-bg border-t border-line" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
                <div className="grid lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-5">
                        <Link to="/" className="flex items-center gap-3">
                            <img
                                src="/ks-logo.png"
                                alt="Konstantin KS Monogram"
                                className="w-12 h-14 object-contain"
                            />
                            <span className="font-display text-3xl tracking-tight">
                                <span className="text-gradient-gold">Konstantin</span>
                                <span className="text-ink/80">.mobile.bg</span>
                            </span>
                        </Link>
                        <p className="text-ink-muted leading-relaxed mt-6 max-w-md">
                            Премиум подбрани автомобили с проверена история, изключително
                            състояние и прозрачна сервизна документация.
                        </p>
                        <div className="flex items-center gap-3 mt-8">
                            <a href={SITE.facebook} target="_blank" rel="noreferrer" aria-label="Facebook"
                               className="w-10 h-10 rounded-full border border-line hover:border-gold/60 hover:text-gold flex items-center justify-center transition-all">
                                <Facebook size={16} />
                            </a>
                            <a href={SITE.mobileBg} target="_blank" rel="noreferrer" aria-label="mobile.bg" title="mobile.bg"
                               className="w-10 h-10 rounded-full border border-line hover:border-gold/60 hover:text-gold flex items-center justify-center transition-all">
                                <Car size={16} />
                            </a>
                            <a href={SITE.tiktok} target="_blank" rel="noreferrer" aria-label="TikTok"
                               className="w-10 h-10 rounded-full border border-line hover:border-gold/60 hover:text-gold flex items-center justify-center transition-all">
                                <Music2 size={16} />
                            </a>
                        </div>
                    </div>

                    <div className="lg:col-span-2">
                        <div className="text-[10px] uppercase tracking-[0.3em] text-gold mb-5">
                            Бързи връзки
                        </div>
                        <ul className="space-y-3 text-ink-muted">
                            <li><Link to="/cars" className="hover:text-gold">Автомобили</Link></li>
                            <li><a href="/#services" className="hover:text-gold">Услуги</a></li>
                            <li><a href="/#about" className="hover:text-gold">За нас</a></li>
                            <li><a href="/#testimonials" className="hover:text-gold">Отзиви</a></li>
                            <li><a href="/#contact" className="hover:text-gold">Контакти</a></li>
                        </ul>
                    </div>

                    <div className="lg:col-span-2">
                        <div className="text-[10px] uppercase tracking-[0.3em] text-gold mb-5">
                            Услуги
                        </div>
                        <ul className="space-y-3 text-ink-muted">
                            <li><a href="/#finance" className="hover:text-gold">Финансиране</a></li>
                            <li><a href="/#tradein" className="hover:text-gold">Бартер</a></li>
                            <li><a href="/#services" className="hover:text-gold">Внос по поръчка</a></li>
                            <li><a href="/#services" className="hover:text-gold">Регистрация</a></li>
                            <li><a href="/#services" className="hover:text-gold">Застраховане</a></li>
                        </ul>
                    </div>

                    <div className="lg:col-span-3">
                        <div className="text-[10px] uppercase tracking-[0.3em] text-gold mb-5">
                            Контакти
                        </div>
                        <ul className="space-y-3 text-ink-muted">
                            <li className="flex items-start gap-3">
                                <Phone size={14} className="mt-1 text-gold" />
                                <a href={`tel:${SITE.phoneRaw}`} className="hover:text-gold">{SITE.phone}</a>
                            </li>
                            <li className="flex items-start gap-3">
                                <Mail size={14} className="mt-1 text-gold" />
                                <a href={`mailto:${SITE.email}`} className="hover:text-gold">{SITE.email}</a>
                            </li>
                            <li className="flex items-start gap-3">
                                <MapPin size={14} className="mt-1 text-gold" />
                                <span>{SITE.address}</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-line">
                    {/* SEO keyword block — visible Cyrillic + Latin variants for search engines.
                        Helps queries like: коли, Константин, автокъща Константин, обяви, mobile.bg konstantin, etc. */}
                    <div className="text-[11px] text-ink-subtle leading-relaxed mb-6 max-w-5xl">
                        <p>
                            <strong className="text-ink/70">Автокъща Константин</strong> (Konstantin Mobile) — водеща
                            автокъща в Петрич, България за продажба на премиум автомобили втора ръка, джипове и
                            бусове. Като Konstantin Auto / автокъща Константин Петрич предлагаме коли с проверена
                            история, прозрачна сервизна документация и сключени гаранции.
                        </p>
                        <p className="mt-2">
                            Konstantin-mobile.bg обединява всички наши обяви от mobile.bg на едно място — Mercedes-Benz,
                            BMW, Audi, Volkswagen, Skoda, Porsche, Range Rover, Bentley и още марки. Услуги: внос на
                            автомобили по поръчка, детайлинг, диагностика, регистрация, финансиране и бартер /
                            trade-in.
                        </p>
                        <p className="mt-2 opacity-80">
                            Ключови думи: Константин, Константин мобиле, Константин обяви, автокъща Константин,
                            автокъща Константин Петрич, коли Константин, обяви Константин,
                            Konstantin, Konstantin Mobile, konstantin-mobile.bg, Konstantin Auto, Konstantin Petrich,
                            mobile.bg konstantin, коли втора ръка, автомобили втора ръка, джипове, бусове.
                        </p>
                    </div>
                    <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                        <p className="text-ink-muted text-sm" data-testid="footer-copyright">
                            © {new Date().getFullYear()} {SITE.name}. Всички права запазени.
                        </p>
                        <Link
                            to="/admin/login"
                            className="text-xs tracking-[0.25em] uppercase text-ink-subtle hover:text-gold"
                            data-testid="footer-admin-link"
                        >
                            Админ
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
